import React from 'react';
import { Box, Button } from '@mui/material';

const PageController = ({ activePage, onPageChange }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-around',
        backgroundColor: '#d9eaf8',
        padding: '10px 0',
        borderRadius: 1,
        marginBottom: 2,
      }}
    >
      <Button
        variant={activePage === 'mainColorWheel' ? 'contained' : 'outlined'}
        onClick={() => onPageChange('mainColorWheel')}
      >
        Main Color Wheel
      </Button>
      <Button
        variant={activePage === 'animations' ? 'contained' : 'outlined'}
        onClick={() => onPageChange('animations')}
      >
        Animations
      </Button>
      <Button
        variant={activePage === 'draw' ? 'contained' : 'outlined'}
        onClick={() => onPageChange('draw')}
      >
        Draw
      </Button>
      {/* <Button
        variant={activePage === 'games' ? 'contained' : 'outlined'}
        // onClick={() => onPageChange('draw')}
      >
        Games
      </Button> */}
      {/* <Button
        variant={activePage === 'settings' ? 'contained' : 'outlined'}
        onClick={() => onPageChange('settings')}
      >
        Settings
      </Button> */}
    </Box>
  );
};

export default PageController;
